import { Injectable } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { Article, Unit } from '../../../core/model';
import { PrincipalConfigurationService } from '../../../core/user';

export interface ArticleDetails {
  co2Factor?: string;
  co2FactorUnit?: Unit;
  co2FactorMethod?: string;
  eanCode?: string;
  oldArticleNumber?: string;
  unspsc?: string;
  vendorMaterialNumber?: string;
}

@Injectable({ providedIn: 'root' })
export class ArticleDetailsService {
  getArticleDetails(article?: Article, unitCode?: string): Observable<ArticleDetails> {
    return combineLatest([
      this.principalConfigurationService.isEnabled('enableDisplayCO2'),
      this.principalConfigurationService.isEnabled('enableDisplayUNSPSC'),
    ]).pipe(
      map(([enableDisplayCO2, enableDisplayUNSPSC]) => {
        const oldArticleNumber =
          article?.displayOldArticleNumber && article?.oldArticleNumber ? article.oldArticleNumber : undefined;
        const unspsc = article?.unspsc;
        const vendorMaterialNumber = article?.vendorMaterialNumber;
        if (!!article && !!unitCode) {
          const separator = '|';
          const eanCode = article?.ean?.find((ean) => ean.startsWith(unitCode + separator))?.split(separator)?.[1];
          const co2ValueString = article?.co2Units
            ?.find((co2Unit) => co2Unit.startsWith(unitCode + separator))
            ?.split(separator)?.[1];
          const co2Value = !!co2ValueString ? parseFloat(co2ValueString).toFixed(3) : co2ValueString;
          return {
            co2Factor: enableDisplayCO2 ? co2Value : undefined,
            co2FactorUnit: enableDisplayCO2
              ? article?.units?.find((unit) => unit.locSymbol === unitCode || unit.code === unitCode)
              : undefined,
            co2FactorMethod: enableDisplayCO2 ? article?.carbonCalculationMethod : undefined,
            eanCode,
            oldArticleNumber,
            unspsc: enableDisplayUNSPSC ? unspsc : undefined,
            vendorMaterialNumber,
          };
        }
        return undefined;
      })
    );
  }

  articleDetailsSectionEnabled(): Observable<boolean> {
    return combineLatest([
      this.principalConfigurationService.isEnabled('enableDisplayCO2'),
      this.principalConfigurationService.isEnabled('enableDisplayUNSPSC'),
    ]).pipe(map(([enableDisplayCO2, enableDisplayUNSPSC]) => enableDisplayCO2 || enableDisplayUNSPSC));
  }

  constructor(private principalConfigurationService: PrincipalConfigurationService) {}
}
